import { getOnlyNumbers } from './formatters'

const onlyNumber = /\D/g
const numberOrLetter = /\W/g

const limitTwoLastDigits = /(-\d{2})\d+?$/
const limitThreeLastDigits = /(-\d{3})\d+?$/
const limitFourLastDigits = /(-\d{4})\d+?$/
const limitFourLastCharacters = /(-\w{4})\w+?$/

const splitTwoDigits = /(\d{2})(\d)/
const splitThreeDigits = /(\d{3})(\d)/
const splitFourDigits = /(\d{4})(\d)/
const splitFiveDigits = /(\d{5})(\d)/
const splitSixDigits = /(\d{6})(\d)/

const splitTwoCharacters = /(\w{2})(\w)/
const splitThreeCharacters = /(\w{3})(\w)/

const acceptNothing = ''
const ignoreEverything = '$1'
const dotBetween = '$1.$2'
const hyphenBetween = '$1-$2'
const slashBetween = '$1/$2'

export const cpfMask = (value: string) => {
  return value
    .replace(onlyNumber, acceptNothing)
    .replace(splitThreeDigits, dotBetween)
    .replace(splitThreeDigits, dotBetween)
    .replace(splitThreeDigits, hyphenBetween)
    .replace(limitTwoLastDigits, ignoreEverything)
}

export const currencyMask = (value: string) => {
  const onlyNumbers = parseFloat(getOnlyNumbers(value))
  const replaceDot = (onlyNumbers / 100)
    .toFixed(2)
    .toString()
    .replace('.', ',')
  const response = replaceDot.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  return response
}

const secondLineSplitFiveDigits = /(\d{5}.\d{5}\s\d{5}.\d{6}\n\d{5})(\d)/
const secondLineSplitElevenDigits = /(\d{5}.\d{5}\s\d{5}.\d{6}\n\d{5}.\d{6})(\d)/
const secondLine = /(\d{5}.\d{5}\s\d{5}.\d{6}\n\d{5}.\d{6}\s\d)(\d)/
const thirdLineSplitTwoDigits = /(\d{5}.\d{5}\s\d{5}.\d{6}\n\d{5}.\d{6}\s\d\n\d{2})(\d)/
const lineBreak = '$1\n$2'
const spaceBetween = '$1 $2'

export const barcodeMaskApp = (value: string) => {
  return value
    .replace(onlyNumber, acceptNothing)
    .replace(splitFiveDigits, dotBetween)
    .replace(splitFiveDigits, spaceBetween)
    .replace(splitFiveDigits, dotBetween)
    .replace(splitSixDigits, lineBreak)
    .replace(secondLineSplitFiveDigits, dotBetween)
    .replace(secondLineSplitElevenDigits, spaceBetween)
    .replace(secondLine, lineBreak)
    .replace(thirdLineSplitTwoDigits, spaceBetween)
}

const splitToAddThirdDot = /(\d{5}.\d{5}\s\d{5}.\d{6}\s\d{5})(\d)/
const splitToAddSpaceBetween = /(\d{5}.\d{5}\s\d{5}.\d{6}\s\d{5}.\d{6})(\d)/
const splitToAddLastSpaceBetween = /(\d{5}.\d{5}\s\d{5}.\d{6}\s\d{5}.\d{6}.\d)(\d)/

export const barcodeMaskWeb = (value: string) => {
  return value
    .replace(onlyNumber, acceptNothing)
    .replace(splitFiveDigits, dotBetween)
    .replace(splitFiveDigits, spaceBetween)
    .replace(splitFiveDigits, dotBetween)
    .replace(splitSixDigits, spaceBetween)
    .replace(splitToAddThirdDot, dotBetween)
    .replace(splitToAddSpaceBetween, spaceBetween)
    .replace(splitToAddLastSpaceBetween, spaceBetween)
}
